// extracted by mini-css-extract-plugin
export var chevronIcon = "_73-2";
export var teamName = "_73-1";
export var teamSwitcherButton = "_73-0";